import type { AutomationTrigger } from '@servicetim/shared';

/** One-line human summary of a trigger, for the rules list. */
export function triggerSummary(trigger: AutomationTrigger): string {
  switch (trigger.type) {
    case 'event':
      return trigger.filter ? `${trigger.eventType} (filtered)` : trigger.eventType;
    case 'schedule':
      return `${trigger.cron} (${trigger.timeZone})`;
    case 'sla.breached':
      return trigger.policyId ? 'SLA breached (one policy)' : 'SLA breached (any policy)';
    case 'date_field': {
      const offset = trigger.offsetDays;
      const when = offset === 0 ? 'on' : offset > 0 ? `${offset}d after` : `${-offset}d before`;
      return `${when} ${trigger.field}`;
    }
  }
}
